export default "__VITE_ASSET__CM$MwBbS__";